import {DataTypeEnum, NewTableDef} from 'app/shared/tables/table-column-def';

export class PriceContractsList {
    public static tableInfo(): NewTableDef {
        return {
            tableId: 'PriceContractsList',
            columns: [
                { columnDef: 'id' },
                {
                    field: 'contractType',
                    columnDef: 'contractType',
                    header: 'Typ kontraktu',
                    width: 15,
                },
                {
                    field: 'price',
                    columnDef: 'price',
                    header: 'Cena',
                    width: 10,
                    type: 'number',
                },
                {
                    field: 'validFrom',
                    columnDef: 'validFrom',
                    header: 'Obowiązuje od',
                    width: 8,
                    type: 'date',
                    dataType: DataTypeEnum.Date,
                },
                {
                    field: 'validTo',
                    columnDef: 'validTo',
                    header: 'Obowiązuje do',
                    width: 8,
                    type: 'date',
                    dataType: DataTypeEnum.Date,
                },
                {
                    field: 'editContract',
                    columnDef: 'editContract',
                    header: 'Edytuj / Usuń',
                    width: 3,
                    showSort: false,
                    showSearch: false,
                },
            ],
        };
    }
}
